import React from 'react';
import {
  TableInput,
  TextInput,
  RadioScore,
  RadioScoreTotal,
  RadioInputGroup,
  CustomHtml,
  NumberInput,
  CheckBoxInput,
  MultiTextInput,
  DropDownInput,
  CheckBoxGroup,
  FileUploader,
  DataListInput
} from '../components';

export const mapFieldToElement = field => {
  switch (field.type) {
    case 'table-input': {
      return <TableInput {...field} />;
    }
    case 'text': {
      return <TextInput {...field} />;
    }
    case 'text-area': {
      return <TextInput {...field} textArea={true} />;
    }

    case 'number': {
      return <NumberInput {...field} />;
    }
    case 'multi-text': {
      return <MultiTextInput {...field} />;
    }
    case 'multi-text-area': {
      return <MultiTextInput {...field} textArea={true} />;
    }
    case 'radio': {
      return <RadioInputGroup {...field} />;
    }
    case 'radio-score': {
      return <RadioScore {...field} />;
    }
    case 'radio-score-grand-total': {
      return <RadioScoreTotal {...field} />;
    }
    case 'checkbox': {
      return <CheckBoxInput {...field} />;
    }
    case 'checkbox-group': {
      return <CheckBoxGroup {...field} />;
    }
    case 'custom-html': {
      return <CustomHtml {...field} />;
    }
    case 'dropdown': {
      return <DropDownInput {...field} />;
    }
    case 'file': {
      return <FileUploader {...field} />;
    }
    case 'datalist-text': {
      return <DataListInput {...field} />;
    }
  }
  return '';
};
